import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import { Button, Field, Spinner } from "../components/ui/kit";
import api, { apiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/api/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nové heslo" subtitle="Nastav si nové heslo ke svému účtu."
      footer={<Link to="/login" className="text-accent font-600">Zpět na přihlášení</Link>}>
      {done ? (
        <div className="card p-5 text-[13px] text-success" data-testid="reset-done">
          Heslo bylo změněno. Přesměrováváme tě na přihlášení…
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="Nové heslo" hint="Alespoň 10 znaků, písmena i číslice.">
            <input type="password" className="field" value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••••"
              data-testid="reset-password" required />
          </Field>
          {error && <div className="text-[12.5px] text-danger">{error}</div>}
          <Button className="w-full justify-center" disabled={loading || !token} data-testid="reset-submit">
            {loading ? <Spinner /> : "Uložit heslo"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
